// File: components/engine/systems/physics.ts
import { CANVAS_WIDTH, PLAYER_WIDTH, ENEMY_WIDTH } from "../../config/dimensions";
import { GameInstance } from "../GameInstance";
import { spawnAllyAttack } from "./spawner";
import { spawnParticles } from "./spawner";

const ALLY_ATTACK_COOLDOWN = 45;

export const updateAllies = (game: GameInstance) => {
    // Zoey AI Logic (Swapped to Left)
    game.zoey.targetX = game.player.x - PLAYER_WIDTH;
    game.zoey.x += (game.zoey.targetX - game.zoey.x) * 0.08;
    game.zoey.y += (game.player.y - game.zoey.y) * 0.08;

    if (game.zoey.attackCooldown > 0) {
        game.zoey.attackCooldown--;
    } else {
        game.zoey.attackCooldown = ALLY_ATTACK_COOLDOWN + Math.random() * 20;
        game.zoey.isAttacking = true;
        game.zoey.attackTimer = 20;
        spawnAllyAttack(game, 'ZOEY_SHOCKWAVE');
    }

    if (game.zoey.isAttacking) {
        game.zoey.attackTimer--;
        if (game.zoey.attackTimer <= 0) game.zoey.isAttacking = false;
    }

    // Mira AI Logic (Swapped to Right)
    game.mira.targetX = game.player.x + PLAYER_WIDTH;
    game.mira.x += (game.mira.targetX - game.mira.x) * 0.08;
    game.mira.y += (game.player.y - game.mira.y) * 0.08;

    if (game.mira.attackCooldown > 0) {
        game.mira.attackCooldown--;
    } else {
        game.mira.attackCooldown = ALLY_ATTACK_COOLDOWN + Math.random() * 20;
        game.mira.isAttacking = true;
        game.mira.attackTimer = 15;
        spawnAllyAttack(game, 'MIRA_WAVE');
    }

    if (game.mira.isAttacking) {
        game.mira.attackTimer--;
        if (game.mira.attackTimer <= 0) game.mira.isAttacking = false;
    }

    for (let i = game.allyProjectiles.length - 1; i >= 0; i--) {
        const p = game.allyProjectiles[i];
        p.life--;
        p.x += p.vx;
        p.y += p.vy;

        if (p.life <= 0 || p.y < -100) {
            game.allyProjectiles.splice(i, 1);
        }
    }
};

export const updatePhysics = (game: GameInstance) => {
    // Player Movement (3D: X and Y)
    if (game.keys.ArrowLeft) game.player.vx -= 1.5;
    if (game.keys.ArrowRight) game.player.vx += 1.5;
    if (game.keys.ArrowUp) game.player.vy -= 1.5;
    if (game.keys.ArrowDown) game.player.vy += 1.5;

    game.player.vx *= 0.85;
    game.player.vy *= 0.85;
    game.player.x += game.player.vx;
    game.player.y += game.player.vy;

    if (game.isPlaneStage) {
        const margin = 100;
        if (game.player.x < margin) game.player.x = margin;
        if (game.player.x > CANVAS_WIDTH - PLAYER_WIDTH - margin) game.player.x = CANVAS_WIDTH - PLAYER_WIDTH - margin;
    } else {
        if (game.player.x < 0) game.player.x = 0;
        if (game.player.x > CANVAS_WIDTH - PLAYER_WIDTH) game.player.x = CANVAS_WIDTH - PLAYER_WIDTH;
    }

    // Y Bounds for 3D depth feeling (closer to camera/further away)
    const yMin = 280;
    const yMax = 420;
    if (game.player.y < yMin) game.player.y = yMin;
    if (game.player.y > yMax) game.player.y = yMax;

    // Swing Logic
    if (game.keys.Space && !game.lastSpace) {
        game.player.isSwinging = true;
        game.player.swingTimer = 10;
        if (Math.abs(game.player.vx) > 0.1) game.player.facing = Math.sign(game.player.vx) as 1 | -1;
    }
    game.lastSpace = game.keys.Space;
    if (game.player.swingTimer > 0) game.player.swingTimer--;
    else game.player.isSwinging = false;

    updateAllies(game);

    // Enemy Movement & AI
    game.enemies.forEach(e => {
        e.moveTimer++;

        // Style 4: Mystery Saja Teleports
        if (e.style === 4) {
            if (!e.teleportTimer) e.teleportTimer = 100;
            e.teleportTimer--;

            if (e.teleportTimer <= 0) {
                // Poof effect at old pos
                spawnParticles(game, e.x + e.width / 2, e.y + e.height / 2, "#bdc3c7", 10);

                // Move to random x
                e.x = Math.random() * (CANVAS_WIDTH - ENEMY_WIDTH);
                e.teleportTimer = 100 + Math.random() * 100;

                // Poof effect at new pos
                spawnParticles(game, e.x + e.width / 2, e.y + e.height / 2, "#bdc3c7", 10);
            } else {
                // Gentle float while waiting
                e.x += Math.sin(e.moveTimer * 0.05) * 0.5;
            }
        } else {
            // Standard Movement
            e.x += Math.sin(e.moveTimer * 0.05) * 2;
        }

        if (e.flashTimer > 0) e.flashTimer--;
    });

    // Particle Physics
    for (let i = game.particles.length - 1; i >= 0; i--) {
        const p = game.particles[i];
        p.x += p.vx; p.y += p.vy;
        p.life -= 0.05;
        if (p.life <= 0) game.particles.splice(i, 1);
    }

    // Camera Shake Decay
    if (game.shake > 0) game.shake = Math.max(0, game.shake * 0.9);

    // Golden Honmoon Timer
    if (game.goldenHonmoonTimer > 0) {
        game.goldenHonmoonTimer--;
        if (game.goldenHonmoonTimer === 0) {
            game.callbacks.onUpdateUI(game.score, game.honmoon, game.wave, game.goldenHonmoonTimer);
        }
    }
};